import styled from 'styled-components';

export const ZushiStyled = styled.div``;
